module.exports = __webpack_public_path__ + "img/news-03.6a73a75b.jpeg";